import {
  stratosBackgroundColor,
  stratosBodyTextColor,
  stratosGreenColor,
  whiteOpacity10,
  whiteOpacity30,
} from "src/constants/colors";
import { BreakPoints, IResponsive } from "src/types/responsiveness";

import styled, { createGlobalStyle, css } from "styled-components";

export const MobileMenuContainer = styled.div`
  /**/
`;

export const NavigationMenu = styled.div<IResponsive>`
  height: 100%;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  text-align: center;

  &.mobile_menu {
    flex-direction: column;
    gap: 10px;
    text-align: left;
    align-items: flex-start;

    a.item_with_btm_margin {
      /* margin-bottom: 8px; */
    }
    span {
      margin: 0;
      &.mobile_group_title {
        color: ${whiteOpacity30};
      }
      &.mobile_sub_item {
        margin-left: 1rem;
      }
    }
  }

  span.mobile_group_title {
    /* color: ${whiteOpacity10}; */
    color: blue;
  }

  a {
    text-decoration: none;

    ${({ $viewName }) => {
      switch ($viewName) {
        case BreakPoints.isMd:
          return css`
            margin: 0 0.6rem 0 0.6rem;
          `;
        case BreakPoints.isLg:
          return css`
            margin: 0 0.6rem 0 0.6rem;
          `;
        case BreakPoints.isMobile:
          return css`
            margin: 0;
          `;
        default:
          return css`
            margin: 0 1rem 0 1rem;
          `;
      }
    }}

    span {
      color: #fff;

      &.active {
        color: ${stratosGreenColor};
      }

      &:hover {
        background-color: transparent;
        color: ${stratosGreenColor};
      }
    }
  }
`;

export const NavLinkWithItemsContainer = styled.div<IResponsive>`
  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMd:
        return css`
          margin: 0 0.6rem 0 0.6rem;
        `;
      case BreakPoints.isLg:
        return css`
          margin: 0 0.6rem 0 0.6rem;
        `;
      default:
        return css`
          margin: 0 1rem 0 1rem;
        `;
    }
  }}
`;

// in header

interface IGlobal extends IResponsive {
  whiteColor?: boolean;
  overlayClassName: string;
}

export const GlobalStyle = createGlobalStyle<IGlobal>`
  body {

  .ant-popover {
    width: 100%;
    .ant-popover-inner {
      background-color:${stratosBackgroundColor};
      border: 1px rgba(127, 102, 187, 0.1) solid;
      margin-right: 5px;
    }
    .ant-popover-arrow {
        &::before {
          background-color: ${whiteOpacity10};
        }
    }
  }


} `;

export const LogoImageContainer = styled.div`
  cursor: pointer;
`;

export const LogoNavContainer = styled.div<IResponsive>`
  font-family: Inter;
  flex-grow: 1;
  .logo_image_container {
    display: flex;
    ${({ $viewName }) => {
      switch ($viewName) {
        case BreakPoints.isMd:
          return css`
            width: 150px;
          `;
        default:
          return css`
            width: 180px;
          `;
      }
    }}
  }
`;

export const HeaderContainer = styled.div`
  width: 85%;
  max-width: 1400px;
  display: flex;
  justify-content: center;
  align-items: center;

  .popover_btn_closed,
  .popover_btn_opened {
    border: none;
    background-color: transparent;
    padding: 5px;
    .anticon {
      color: ${stratosBodyTextColor};
      align-items: center;
      display: flex;

      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
`;
